module.exports = __webpack_public_path__ + "img/distributors-mobile.bad7e2b5.jpg";